import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

import Header from "./components/Header";
import Hero from "./components/Hero";
import Paths from "./components/Paths";
import HowItWorks from "./components/HowItWorks";
import LeadForm from "./components/LeadForm";
import Offers from "./components/Offers";
import Benefits from "./components/Benefits";
import Trust from "./components/Trust";
import FAQ from "./components/FAQ";
import FinalCTA from "./components/FinalCTA";
import Footer from "./components/Footer";
import WhatsAppFloat from "./components/WhatsAppFloat";

function Landing() {
  return (
    <div className="min-h-screen bg-background text-foreground" dir="rtl">
      <Header />
      <main>
        <Hero />
        <Paths />
        <HowItWorks />
        <LeadForm />
        <Offers />
        <Benefits />
        <Trust />
        <FAQ />
        <FinalCTA />
      </main>
      <Footer />
      <WhatsAppFloat />
      <Toaster position="top-center" richColors closeButton />
    </div>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
